import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { GroupsUsersService } from "../../services/groups/groups-users.service";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "../../services/translate/translate.service";
import { Subscription } from "rxjs";

export type EmailsGroups = {
  email: string;
  status: string;
};
@Component({
  selector: "mg-modal-add-users-groups",
  templateUrl: "./modal-add-users-groups.component.html",
  styleUrls: ["./modal-add-users-groups.component.scss"],
})
export class ModalAddUsersGroupsComponent implements OnInit, OnDestroy {
  email: string = "";
  emailsGroups: EmailsGroups[] = [];
  loading: boolean = false;
  subscriptionTranslate!: Subscription;
  dataTranslateUserGroups!: any;

  constructor(
    public dialogRef: MatDialogRef<ModalAddUsersGroupsComponent>,
    private groupsUsersService: GroupsUsersService,
    private toast: ToastrService,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: string[]
  ) {}

  ngOnInit(): void {
    this.getTranslate();
  }
  save() {
    if (this.emailsGroups.length > 0) {
      this.dialogRef.close({ resp: true, users: this.emailsGroups });
    }
  }

  close() {
    this.dialogRef.close({ resp: false });
  }

  validateEmail() {
    this.loading = true;
    if (!this.emailsGroups.some((item) => item.email === this.email)) {
      this.emailsGroups.push({
        email: this.email,
        status: this.data[0],
      });
    }
    this.email = "";
    this.loading = false;
  }
  selectionChange(index: number, { value }: { value: string }) {
    const item: EmailsGroups = this.emailsGroups[index];
    const newEmail: EmailsGroups = {
      email: item.email.toLowerCase(),
      status: value,
    };
    this.emailsGroups.splice(index, 1, newEmail);
  }
  deleteItem(i: number) {
    this.emailsGroups.splice(i, 1);
  }

  getTranslate() {
    this.subscriptionTranslate = this.translate.init("core").subscribe((data) => {
      this.dataTranslateUserGroups = data.userGroups.modalAddGroups;
    });
  }
  ngOnDestroy(): void {
    this.subscriptionTranslate?.unsubscribe();
  }
}
